'use strict';

(function () {

  angular.module('specsguardApp')
    .config(ProjectAdminConfig);

  ProjectAdminConfig.$inject = ['$stateProvider'];

  function ProjectAdminConfig ($stateProvider) {
    $stateProvider

      .state('project/administration', {
        url: '/project/{project_id}/administration',
        templateUrl: 'app-legacy/project/administration/project.administration.html',
        controller: 'ProjectAdministrationCtrl',
        controllerAs: 'projAdminCtrl',
        menu: {
          context: 'project',
          title: '[ProjectName]',
          subtitle: '[Beheer]'
        },
        notifications: [
          {
            room: '/project/:id',
            includes: {
              path: []
            }
          }
        ],
        authenticate: true,
        needRole: 5,
        resolve: {
          project: ['ProjectDataservice', '$stateParams', function (ProjectDataservice, $stateParams) {
            ProjectDataservice.resetProjectById($stateParams.project_id);
            return ProjectDataservice.getProjectById($stateParams.project_id);
          }],
          users: ['User', (UserAPI) => UserAPI.query({
            currentTenant: true,
          }).$promise],
        }
      });
  }

})();
